// extracted by mini-css-extract-plugin
export default {"projectsHeader":"ProjectsHeader_projectsHeader__L5tV7","toBottom":"ProjectsHeader_toBottom__ZQLVQ"};